import { ContestShapefileStatus } from '../../app/feathers/contest-shapefiles';

interface ContestShapefileQueryOptions {
  electionKey: string;
  stage: ContestShapefileStatus | '';
  search: string;
  page: number;
  pageSize: number;
}

export const buildContestShapefileQuery = ({
  electionKey,
  stage,
  search,
  page,
  pageSize
}: ContestShapefileQueryOptions) => ({
  election: electionKey,
  ...(stage ? { status: stage } : {}),
  ...(search ? { $search: search } : {}),
  $skip: page * pageSize,
  $limit: pageSize,
  $sort: { createdAt: -1 as const }
});
